module.exports = __webpack_public_path__ + "img/csr_swiper_05_mobile.054cb8e2.jpg";